import type { GenerationDetail, GenerationSummary } from '../model/types';

/**
 * «Повторить · 1 жетон» в записи (ТЗ главной § 22.6): `POST /cards/{id}/regenerate` возвращает
 * карточку, а не запись, поэтому после успеха запись сразу показывает то, что будет: элемент
 * «генерируется», запись «генерируем» — пока SSE или опрос не принесут настоящую сводку.
 * Чистые функции без alias-импортов.
 */

/** Сводка без элементов — для кэша списка и слежения. */
export function summaryOfDetail(detail: GenerationDetail): GenerationSummary {
  const { items: _items, ...summary } = detail;
  return summary;
}

/** Элемент снова генерируется: тот же card_id и тот же выбор, содержимое пересобирается. */
export function markItemRetrying(detail: GenerationDetail, itemId: string): GenerationDetail {
  if (!detail.items.some((item) => item.id === itemId)) return detail;
  return {
    ...detail,
    items: detail.items.map((item) =>
      item.id !== itemId
        ? item
        : {
            ...item,
            status: 'generating',
            problem: null,
            removal: null,
            meanings: item.meanings.map((meaning) => ({
              ...meaning,
              senses: meaning.senses.map((sense) => ({ ...sense, status: 'generating' as const })),
            })),
          },
    ),
  };
}

/** Запись после успешного «Повторить»: «генерируем», упавший элемент — среди идущих. */
export function summaryAfterRetry(summary: GenerationSummary): GenerationSummary {
  const { counts } = summary;
  return {
    ...summary,
    status: 'generating',
    counts: { ...counts, failed: Math.max(0, counts.failed - 1), generating: counts.generating + 1 },
  };
}
